export type ReactionSender = 'Supplier' | 'Customer';

export const ReactionSender = {
  Supplier: 'Supplier' as ReactionSender,
  Customer: 'Customer' as ReactionSender
};